import React from 'react';
import { cn } from '@strivelabs/ui-core';

export interface ChartTooltipContentProps {
  active?: boolean;
  payload?: any[];
  label?: string;
  labelFormatter?: (label: string) => string;
  valueFormatter?: (value: any) => string;
  className?: string;
  hideLabel?: boolean;
  hideIndicator?: boolean;
  indicator?: 'line' | 'dot' | 'dashed';
  nameKey?: string;
  labelKey?: string;
}

export const ChartTooltipContent: React.FC<ChartTooltipContentProps> = ({
  active,
  payload,
  label,
  labelFormatter,
  valueFormatter,
  className,
  hideLabel = false,
  hideIndicator = false,
  indicator = 'dot',
  nameKey = 'name',
  labelKey = 'value',
}) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        'rounded-lg border bg-background p-2 shadow-md',
        className
      )}
    >
      {!hideLabel && label && (
        <div className="mb-2 font-medium">
          {labelFormatter ? labelFormatter(label) : label}
        </div>
      )}
      <div className="grid gap-1.5">
        {payload.map((entry, index) => {
          const indicatorColor = entry.color || entry.fill || entry.stroke;
          
          return (
            <div
              key={`item-${index}`}
              className="flex items-center gap-2 text-sm"
            >
              {!hideIndicator && (
                <div
                  className={cn(
                    'shrink-0',
                    indicator === 'dot' && 'h-2.5 w-2.5 rounded-full',
                    indicator === 'line' && 'h-0.5 w-3',
                    indicator === 'dashed' && 'h-0.5 w-3 border-t-2 border-dashed'
                  )}
                  style={{
                    backgroundColor:
                      indicator !== 'dashed' ? indicatorColor : undefined,
                    borderColor:
                      indicator === 'dashed' ? indicatorColor : undefined,
                  }}
                />
              )}
              <div className="flex flex-1 justify-between gap-2">
                <span className="text-muted-foreground">
                  {entry[nameKey] || entry.dataKey}
                </span>
                <span className="font-medium tabular-nums">
                  {valueFormatter
                    ? valueFormatter(entry[labelKey])
                    : entry[labelKey]}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};